import { ApiService } from "Services/ApiService";
import { LocType, GetAllLocTypesParams } from "Types/Admin/AdminLocType";
import { ResultsDTO } from "Types/ResultsDTO";

export const LocTypeApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getAllLocTypes: builder.query<LocType[], GetAllLocTypesParams>({
      query: (params) => ({
        url: "LocType/getAll",
        params,
      }),
      transformResponse: (res: ResultsDTO<LocType[]>) => res.results ?? [],
      providesTags: ["LocType"],
    }),
  }),
});

export const { useGetAllLocTypesQuery } = LocTypeApiSlice;
